import { useGLTF } from "@react-three/drei";
import { useRef, useEffect } from "react";

export default function Frog(props) {
  const { scene } = useGLTF("/frog/frog4.glb");
  const frogRef = useRef();

  // Allow the frog to cast/receive shadows if your scene uses them
  useEffect(() => {
    scene.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [scene]);

  return <primitive ref={frogRef} object={scene} {...props} />;
}
